
/**
 * Used to print the file size string
 * @param {Number} bytes
 */
export function fileSize(bytes) {
  const Kb = bytes / 1000.0;
  const Mb = bytes / 1000000.0;
  if (Kb < 1000.0) {
    return `${Math.ceil(Kb)} KB`;
  }
  return `${Math.ceil(Mb)} MB`;
}

/**
 * Converts an object into an array
 * Used to convert the files ref into a state array
 * @param {object[]} files
 */
export function objectToArray(files) {
  if (files && Object.keys(files)) {
    const filesArray = [];

    Object.keys(files).map(file => {
      filesArray.push(files[file]);
      return undefined;
    });

    return filesArray;
  }
  return [];
}
